import React from "react";
import { Typography } from "@mui/material";
import Button from "@mui/material/Button";
import Div from "@jumbo/shared/Div";

const Footer = () => {
  const d = new Date();
  let currentYear = d.getFullYear();
  let appFooter = "Advangelists LLC, A Mobiquity Technologies Company";
  const currentDomain = window.location.hostname;
  if (currentDomain.indexOf("adfuel.us") != -1) {
    appFooter = "Adfuel Media Inc.";
  } else if (currentDomain.indexOf("contextnetworks.net") != -1) {
    appFooter = "Context Networks.";
  } else if (currentDomain.indexOf("savvydsp.com") != -1) {
    appFooter = "Savvy Media.";
  } else if (currentDomain.indexOf("perfectaudience.io") != -1) {
    appFooter = "Perfect Audience.";
  } else if (currentDomain.indexOf("arrowmarketinglabs.com") != -1) {
    appFooter = "Arrow Marketinglabs.";
  }
  return (
    <Div
      sx={{
        py: 1,
        px: { lg: 6, xs: 4 },
        borderTop: 2,
        borderColor: "divider",
        bgcolor: "background.paper",
      }}
    >
      <Div
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Typography variant={"body1"} color={"text.primary"}>
          {appFooter} © {currentYear}
        </Typography>
        {/* <Div sx={{ display: "flex", alignItems: "center" }}>
          <Typography
            variant="h5"
            sx={{
              display: { xs: "none", sm: "block" },
              mb: 0,
              mr: 2,
              color: "primary.main",
            }}
          >
            $24 Only
          </Typography>
          <Button variant="contained">Buy Now</Button>
        </Div> */}
      </Div>
    </Div>
  );
};

export default Footer;
